import api from '../axios/axiosInstance';

export interface RangeReport {
  startDate: string;
  endDate: string;
  days: {
    date: string;
    grossSales: number;
    refunds: number;
    discounts: number;
    netSales: number;
    grossProfit: number;
    totalCOGS: number;
  }[];
  totals: {
    grossSales: number;
    refunds: number;
    discounts: number;
    netSales: number;
    grossProfit: number;
    totalCOGS: number;
  };
  percentageChanges: {
    grossSales: number;
    refunds: number;
    discounts: number;
    netSales: number;
    grossProfit: number;
    totalCOGS: number;
  };
}

const getRangeReports = async ({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RangeReport> => {
  const res = await api.get('/reports/range', {
    params: {
      startDate,
      endDate,
    },
  });
  return res.data;
};

export default getRangeReports;
